module.exports = __webpack_public_path__ + "img/album03_08.ab0af434.jpg";